// /sso: where account.olenesoft.com sends people between Olene apps (auth/oleneSso.js).
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { ticketSignIn } from "../auth/olene";
import { handleSsoLanding, hubFor } from "../auth/oleneSso";
import { STAGE } from "../stage";

export const HUB = hubFor(STAGE);

export default function Sso() {
  const auth = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    handleSsoLanding({
      app: "payclear",
      hub: HUB,
      accessToken: () => auth.getAccessToken(),
      ticketSignIn: async (u, t, n) => auth.setSession(await ticketSignIn(u, t, n)),
    }).then((r) => {
      if (r.kind !== "redirected") navigate(r.kind === "signIn" && r.to === "/" ? "/signin" : r.to, { replace: true });
    });
  }, [auth, navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p role="status" className="text-gray-500 text-sm">Signing you in…</p>
    </div>
  );
}
